import type { DeepReadonly, Ref } from 'vue'
import type { Slide } from '~/entities/deck'

export function useDeckSetActiveThreeDScene({
  slides,
  currentSlideIndex,
  slideRefreshKey,
  setActiveScene,
}: {
  slides: DeepReadonly<Ref<Slide[] | undefined>>
  currentSlideIndex: Ref<number>
  slideRefreshKey: Ref<number>
  setActiveScene: (modelId: number, cameraId: number | null, options?: { shouldTween?: boolean }) => Promise<void>
}): void {
  const route = useRoute()
  const { noTween } = route.query

  watch(
    [() => slides.value?.[currentSlideIndex.value], slideRefreshKey],
    async ([slide, newSlideRefreshKey], [oldSlide, oldSlideRefreshKey]) => {
      const shouldTween = !noTween && oldSlide?.type === 'M'

      if (slide?.type === 'M') {
        if (newSlideRefreshKey && newSlideRefreshKey === oldSlideRefreshKey) return
        await setActiveScene(slide.model_id, slide.camera_id, { shouldTween: shouldTween })
      }
    },
  )
}
